import React from 'react';
import { Platform } from 'react-native';
import { Redirect } from 'expo-router';
import MetaHead from '@/components/MetaHead';
import DeckView from '@/components/Deck/DeckView';
import { useTranslation } from '@/hooks/useTranslation';

// Deck is a desktop-scale multi-column workspace. The phone apps don't ship
// it, so the route sends them home rather than rendering a surface that
// doesn't fit. Web and macOS are unaffected.
const IS_TOUCH_NATIVE = Platform.OS === 'ios' || Platform.OS === 'android';

// The Deck route is the user's authenticated multi-column workspace.
// `DeckView` handles three states internally:
//   1. No decks yet           → renders the full `DeckMockup` empty-state
//                               hero (recipes grid + auto-scrolling preview).
//   2. Has decks, no slug     → activates the first deck, mirrors `?d=` URL.
//   3. Has decks + ?d=<slug>  → switches to that deck.
//
// Per-deck state and tab management live in `useDeckStore` (see
// frontend/store/index.js). Backed by `Deck` and `DeckTemplate` mongoose
// models — the deck list is server-synced and persisted across devices.
export default function DeckRoute() {
  if (IS_TOUCH_NATIVE) return <Redirect href="/" />;
  return <DeckWorkspace />;
}

function DeckWorkspace() {
  const { t } = useTranslation();
  return (
    <>
      <MetaHead
        title={t('pages.deck.title')}
        description={t('pages.deck.description')}
        canonical="/deck"
      />
      <DeckView />
    </>
  );
}
